// Translation: Account > Profile > Networks (English)
export default Object.freeze({
	form: {
		fields: {
			profileGitHub: {
				label: 'GitHub',
				placeholder:'Enter GitHub profile link'
			},
			profileGoogleScholar: {
				label: 'Google Scholar',
				placeholder:'Enter Google Scholar profile link'
			},
			profileLinkedIn: {
				label: 'LinkedIn',
				placeholder:'Enter LinkedIn profile link'
			}
		}
	},
	title: 'Networks'
})
